import React from "react";

import clsx from "clsx";

import { Handle, HandleProps, Position } from "@xyflow/react";

import { GitForkIcon } from "lucide-react";

type CustomHandleProps = HandleProps & {
    type: "source" | "target";
    position: Position;
    variant: "default" | "modified";
};

export function CustomHandle({
    type,
    position,
    isConnectable,
    variant,
    className,
    ...props
}: CustomHandleProps) {
    return (
        <Handle
            {...props}
            type={type}
            position={position}
            isConnectable={isConnectable}
            className={clsx(
                className,
                "!bg-[#191B33] rounded-full flex items-center justify-center !z-50",
                {
                    "!w-2 !h-2": variant === "default",
                    "!w-6 !h-6": variant === "modified",
                },
            )}
        >
            {variant === "modified" && (
                <GitForkIcon className="w-[14px] h-[14px] text-white -z-10" />
            )}
        </Handle>
    );
}
